import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent, SocialComponent } from '@rx-lib/ui';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RxLet } from '@rx-angular/template/let';
import { ActivatedRoute } from '@angular/router';
import { Page } from '@rx-lib/ui';
import { RouteMapEntry } from '@rx-lib/models';

@Component({
  selector: 'lib-contact',
  standalone: true,
  imports: [CommonModule, SocialComponent, ContentComponent, RxLet],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent {

  private currentRoute$: Observable<RouteMapEntry> = inject(ActivatedRoute).snapshot.data['currentRoute'];

  public page$: Observable<Page> = this.currentRoute$.pipe(
    // tap((currentRoute) => console.log('ContactComponent currentRoute', currentRoute)),
    map((currentRoute) => currentRoute.page),
    // tap((page) => console.log('ContactComponent page', page)),
    take(1)
  );

}
